import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import CustomButton from "../../../common/CustomButton";
import { DeleteIcon, EditIcon } from "../../../../assets/svg/svg-icons";
import { useSelector, useDispatch } from "react-redux";
import { deleteProductVariant, getApi } from "../../../../actions/structure.action";
import isEmpty from "../../../../utils/is-Empty";
import { tableStructures } from "../../../../helpers/table-structures";
import Spinner from "../../../common/Spinner";
import CustomSelectDropdown from "../../../common/CustomSelectDropdown";
import CustomTable from "../../common/CustomTable";
import VariantsCrud from "../../common/VariantsCrud";
import { useDialog } from "../../../../helpers/useDialog";

const Variants = () => {
  const dispatch = useDispatch();
  const { alert, confirm, DialogModal } = useDialog();
  const [showVariantCRUD, setShowVariantCRUD] = useState(false);
  const [selectedFormObj, setSelectedFormObj] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState({});
  const [variantOptions, setVariantOptions] = useState([]);
  const [createVariant, setCreateVariant] = useState({});

  const [options, setOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const { products, currentProduct, bhareeAdminBasicTable } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    getApi("getProducts", dispatch);
  }, [dispatch]);

 useEffect(() => {
  setIsUpdateMode(false);

  if (products?.data?.length > 0) {
    // -----------------------------
    // PRODUCT CATEGORIES
    // -----------------------------
    const categoryMap = {};

    products.data.forEach((item) => {
      const categoryName = item?.productCategory?.name;

      if (categoryName) {
        categoryMap[categoryName] = {
          id: categoryName,
          displayName: categoryName,
        };
      }
    });

    const categories = Object.values(categoryMap);

    setCategoryOptions(categories);

    // Select first category by default
    if (categories.length > 0) {
      setSelectedCategory(categories[0]);

      onSelectValue(categories[0], "selectedCategory");
    }

    // -----------------------------
    // ALL PRODUCTS
    // -----------------------------
    const optionsArray = products.data.map((item) => ({
      id: item.id,
      displayName: `${item?.brand?.brand_name} ${item?.productCategory?.name}`,
      categoryName: item?.productCategory?.name,
      createdAt: item.createdAt,
    }));

    const sortedDesc = [...optionsArray].sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    setOptions(sortedDesc);

    // Don't automatically select product here
    // Product will be selected after category filtering
  }

  if (products?.data?.length < 1) {
    setShowVariantCRUD(true);
  } else {
    setShowVariantCRUD(false);
  }
}, [products]);
useEffect(() => {
  if (!selectedCategory || !products?.data?.length) {
    return;
  }

  const filteredProducts = products.data
    .filter(
      (item) =>
        item?.productCategory?.name === selectedCategory?.displayName
    )
    .map((item) => ({
      id: item.id,
      displayName: `${item?.brand?.brand_name} ${item?.productCategory?.name}`,
      categoryName: item?.productCategory?.name,
      createdAt: item.createdAt,
    }))
    .sort(
      (a, b) =>
        new Date(b.createdAt) - new Date(a.createdAt)
    );

  setOptions(filteredProducts);

  // Clear old product selection
  setSelectedFormObj((previousValues) => ({
    ...previousValues,
    selectedProduct: undefined,
  }));

  // Select first product from selected category
  if (filteredProducts.length > 0) {
    onSelectValue(filteredProducts[0], "selectedProduct");
  }
}, [selectedCategory, products]);

  useEffect(() => {
    if (
      !isEmpty(currentProduct?.data.selectedVariants) &&
      currentProduct?.data?.selectedVariants?.length > 0 &&
      bhareeAdminBasicTable?.data?.variants?.length > 0
    ) {
      const idsInA = currentProduct?.data?.selectedVariants.map((itemA) => itemA.variant_id);
      const filtered = bhareeAdminBasicTable?.data?.variants.filter(
        (itemB) => !idsInA.includes(itemB.id)
      );
      setVariantOptions(filtered);
    } else {
      setVariantOptions(bhareeAdminBasicTable?.data?.variants);
    }
  }, [currentProduct, bhareeAdminBasicTable]);

  useEffect(() => {
    console.log("selectedFormObj: ", selectedFormObj);
    if (selectedFormObj?.selectedProduct?.id) {
      getApi("getProductById", dispatch, "/" + selectedFormObj?.selectedProduct?.id);
      setCreateVariant({ product_id: selectedFormObj?.selectedProduct?.id });
    }
  }, [selectedFormObj, dispatch]);

  const onSelectValue = (value, selectorType) => {
    let updatedObj = {};
    updatedObj[selectorType] = value;
    setSelectedFormObj((previousVlaues) => ({
      ...previousVlaues,
      ...updatedObj,
    }));
  };

  useEffect(() => {
    if (!showVariantCRUD) {
      setIsUpdateMode(false);
    } else {
      setIsUpdateMode(true);
    }
  }, [showVariantCRUD]);

  return (
    <Container className="slller-products p-3">
      {DialogModal}
      <Row className="mx-0 px-1 mb-2">
        <h1 className="text-uppercase">{"Product Variants"}</h1>
      </Row>
      {currentProduct.loading ? (
        <Container className="seller-product-create-form   ">
          <Spinner />
        </Container>
      ) : options?.length > 0 ? (
        <>
          <Row className="m-0 w-full  form-row ">
            <Form className="my-0 p-0 modal-custom-class">
              <Row className="m-0">
               <Col xs={12} md={6}>

  {/* PRODUCT CATEGORY */}
  <Form.Group className="mb-3">
    <Form.Label>
      {"Select Product Category"}
      <span className="redStreSpan">{"*"}</span>
    </Form.Label>

    {categoryOptions?.length > 0 && (
      <CustomSelectDropdown
        style={{
          multiselectContainer: {
            backgroundColor: "#f8f8f8",
          },
          chips: {
            margin: 0,
          },
          option: {
            background: "#fbb040",
            color: "#FFFFFF",
            borderBottom: "1px solid #FFFFFF",
          },
        }}
        options={categoryOptions}
        onSelect={(e) => {
          const category = e?.[0];

          setSelectedCategory(category);

          onSelectValue(category, "selectedCategory");
        }}
        selectedValues={
          selectedCategory ? [selectedCategory] : []
        }
        displayValue={"displayName"}
        disable={isUpdateMode}
        singleSelect
      />
    )}
  </Form.Group>


  {/* PRODUCT */}
  <Form.Group className="mb-3">
    <Form.Label>
      {"Select Product"}
      <span className="redStreSpan">{"*"}</span>
    </Form.Label>

    {options?.length > 0 && (
      <CustomSelectDropdown
        style={{
          multiselectContainer: {
            backgroundColor: "#f8f8f8",
          },
          chips: {
            margin: 0,
          },
          option: {
            background: "#fbb040",
            color: "#FFFFFF",
            borderBottom: "1px solid #FFFFFF",
          },
        }}
        options={options}
        onSelect={(e) =>
          onSelectValue(e[0], "selectedProduct")
        }
        selectedValues={
          Object.prototype.hasOwnProperty.call(
            selectedFormObj,
            "selectedProduct"
          )
            ? [selectedFormObj?.selectedProduct]
            : []
        }
        displayValue={"displayName"}
        disable={isUpdateMode}
        singleSelect
      />
    )}
  </Form.Group>

</Col>
              </Row>
            </Form>
          </Row>
          {currentProduct?.data?.selectedVariants?.length > 0 && !showVariantCRUD ? (
            <Row className="variant-options-table-row mt-4">
              <CustomTable
                columns={tableStructures.crud_variant}
                data={currentProduct.data.selectedVariants}
                enableRowActions={true}
                positionActionsColumn={"last"}
                enableTopToolbar={true}
                emptyTableMsg={""}
                enableBottomToolbar={true}
                enablePagination={true}
                enableFilters={true}
                renderTopToolbarCustomActions={() => (
                  <div className="table-heading-wrap">
                    <h4>{"Variants"}</h4>
                    <CustomButton
                      buttonClasses="icon-add-btn"
                      onClick={() => {
                        setSelectedVariant({});
                        setCreateVariant({ product_id: selectedFormObj?.selectedProduct?.id });
                        setIsUpdateMode(false);
                        setShowVariantCRUD(true);
                      }}
                    >
                      <i className="bi bi-plus"></i>
                      {"Add"}
                    </CustomButton>
                  </div>
                )}
                renderRowActions={({ row }) => (
                  <div className="table-action-box">
                    <CustomButton
                      buttonClasses="icon-action-btn"
                      onClick={() => {
                        setSelectedVariant(row.original);
                        setIsUpdateMode(true);
                        setShowVariantCRUD(true);
                      }}
                    >
                      <EditIcon />
                    </CustomButton>
                    {currentProduct.data.selectedVariants?.length > 1 && (
                      <CustomButton
                        buttonClasses="icon-action-btn"
                        onClick={() => deleteProductVariant(row.original.id, dispatch, confirm)}
                      >
                        <DeleteIcon />
                      </CustomButton>
                    )}
                  </div>
                )}
                initialState={{
                  columnPinning: {
                    right: ["mrt-row-actions"],
                  },
                }}
              />
            </Row>
          ) : (
            <div className="seller-product-create-form  mt-4 ">
              <VariantsCrud
                variant={selectedVariant}
                createVariant={createVariant}
                createVariantOptions={variantOptions}
                setShowVariantCRUD={setShowVariantCRUD}
              />
            </div>
          )}
        </>
      ) : (
        <Container className="seller-product-create-form   ">
          <h6>{"Please create product first"} </h6>
        </Container>
      )}
    </Container>
  );
};

export default Variants;
